import './tutorialModule.css'; // Create a CSS file for module-specific styling

export const TutorialModule = ({ zoomScale }) => {

  return (
    <div className="tutorial-module">
        <h2 id="tutorial-module-title">Bienvenue sur Infobligations</h2>
        <div id="tutorial-module-text">
            <p className="tutorial-module-paragraph">
                Infobligations est une infographie interactive qui présente les obligations que doivent respecter les éditeurs de services audiovisuels en France.
            </p>
        </div>
        <ol id="tutorial-steps-list">
            <li className="tutorial-steps-item">
                Choisissez un diffuseur dans le module ci-dessous.
            </li>
            <li className="tutorial-steps-item">
                Comparez plusieurs diffuseurs en cliquant sur le bouton "Ajouter un module".
            </li>
            <li className="tutorial-steps-item">
                Vous pouvez zoomer n'importe où sur l'écran et repositionner chaque module individuellement.
            </li>
            <li className="tutorial-steps-item">
                La visualisation des obligations de financement montre les minima à respecter en matière de financement de la création cinématographique et audiovisuelle. 
                L'imbrication de plusieurs niveaux d'obligations est représentée visuellement par l'appartenance de chaque barre à un "parent", rendu visible lorsque vous survolez la barre avec votre souris.
            </li>
            <li className="tutorial-steps-item">
                Les pourcentages sont automatiquement convertis en valeurs absolues lorsque vous renseignez un chiffre d'affaires.
            </li>
        </ol>
    </div>
  );
};